import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../ReducerRegister";
import EditService from "../../../../services/screens/admin/talkchinese/EditService";
import { ActionTypes } from "../../../actionTypes/screens/admin/talkchinese/EditActionTypes";
import AsyncActionReducers from "../../../AsyncActionReducers";

import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.talkchinese.edit;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: id => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC, id });

            EditService.loadScreenView(
                id,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: data => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    saveAsync: vo => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.SAVE_ASYNC, vo });

            EditService.save(
                vo,
                response => {
                    dispatch(Actions.saveSuccess(response));
                },
                error => {
                    dispatch(Actions.saveFailure(error));
                }
            );
        };
    },

    saveSuccess: data => ({
        type: ActionTypes.SAVE_SUCCESS,
        parentType: ActionTypes.SAVE_ASYNC,
        data
    }),

    saveFailure: error => ({
        type: ActionTypes.SAVE_FAILURE,
        parentType: ActionTypes.SAVE_ASYNC,
        error
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    book: {}
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data }) => {
    return { ...state, book: data.book };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SAVE_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.SAVE_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.SAVE_FAILURE]: AsyncActionReducers.failureReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
